import React from "react";
import { Dropdown } from "semantic-ui-react";
import { Link, useHistory } from "react-router-dom";

export default function APIVersionDropdown(params) {
    const history = useHistory();

    const versionOptions = [
        {
            key: "v1",
            text: params.version === "v1" ? "v1 (selected)" : "v1",
            value: "v1",
            description: "Existing docs",
        },
        {
            key: "v2",
            text: params.version === "v2" ? "v2 (selected)" : "v2",
            value: "v2",
            description: "New docs",
        },
    ];

    const onVersionChange = (e, { value }) => {
        if (value === "v2") {
            history.push("/public/api-documentation/v2");
        } else {
            history.push("/public/api-documentation");
        }
    };

    return (
        <div className='row mt-4'>
            <div
                className='col-12'
                style={{ display: "flex", justifyContent: "flex-end" }}
            >
                <Dropdown
                    selection
                    options={versionOptions}
                    onChange={onVersionChange}
                    value={params.version}
                />
            </div>
        </div>
    );
}
